import { Box, Dialog } from 'edenred-ui';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 985px !important;
    width: 985px !important;
  }
`;

export const ErrorCounterBadge = styled(Box)`
  margin-left: 8px;
  background-color: ${props => props.theme.warningColor};
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.theme.sizeExtraSmall};
  font-weight: ${props => props.theme.fontSemiBold};
`;
